import { ProOptions } from 'reactflow'

const proOptions: ProOptions = { hideAttribution: true }

export default proOptions
